import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { SettingsComponent } from '../settings/settings.component';
import { menuData } from './hamerburg-menu-data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { AccountOptionPage } from '../../modal-screens/account-option/account-option.page';
import { Observable } from 'rxjs';
import { ClubMembershipExtended, PlayerInfo } from 'src/data/mygolf.data';
import { PlayerHomeActions } from 'src/redux/player-home';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import * as globals from 'src/globals';
import { MessageDisplayUtil } from 'src/message-display-utils';

@Component({
  selector: 'app-hamerburg-menu',
  templateUrl: './hamerburg-menu.component.html',
  styleUrls: ['./hamerburg-menu.component.scss'],
})
export class HamerburgMenuComponent implements OnInit {

  @Input() signout: () => void;
  @Input() main: any;
  @Input() isNormaleGameOn: any;
  @Input() isCompOn: any;
  @Input() isCompSingleOrMulti: string;
  @Input() appAttribute: any;
  helpURL: string;
  menuData = menuData;
  selectedMenu: any;
  filteredMenu: any[] = [];
  storeMenuData = menuData;
  activeButtonIndex = 0;
  public player$: Observable<PlayerInfo>;

  settingsAppAttribute: any;
  isClubSpecific: boolean = false;

  @Input() menuItems: Array<any>;
  @Input() homeMembership: ClubMembershipExtended;
  constructor(
    private mdlCtrl: ModalController,
    private router: Router,
    private platform: Platform,
    private flightService: ClubFlightService,
    private playerHomeActions: PlayerHomeActions,
    private mg2uUtil: mygolfUtils,
    private toastCtl: ToastController,

  ) {
    this.filteredMenu = [...menuData];
    
    this.settingsAppAttribute = this.mg2uUtil.getSettingsAttribute();
    this.isClubSpecific = this.mg2uUtil.getClubSpecific();
  }

  ngOnInit() {
    this.selectedMenu = this.menuData.find((item) => item.title === 'Booking');
    // if(this.homeMembership?.playerHomeClub)
    //   this.selectedMenu = this.menuData.find((item) => item.title === 'Memberships');

    this.selectMenuItem(this.selectedMenu);
      console.debug("home membership ", this.homeMembership);

    console.log('this.normalGameOn: ', this.isNormaleGameOn);
    const scoreRoundItem = this.filteredMenu?.find((item) => item.title === 'Events & Scoring')['submenu'].find((a) => a.id === 1);
    if (this.isNormaleGameOn) {
      if (scoreRoundItem) {
        scoreRoundItem.label = 'Game in progress'
      }
    }else{
      if (scoreRoundItem) {
        scoreRoundItem.label = 'New Game / Score Round'
      }
    }

  }

  selectMenuItem(data: any) {
    this.selectedMenu = data;
    const startIndex = this.filteredMenu.findIndex((menu) => menu.title === data.title);
    this.activeButtonIndex = startIndex
    // let filterMenuValueStore = this.filteredMenu[0]
    // this.filteredMenu[0] = this.filteredMenu[startIndex];
    // this.filteredMenu[startIndex] = filterMenuValueStore;

  }

  menuSelectItem(item: any) {
    this.checkMenuItem(item)
      .then((result: any)=>{
        console.debug("check menu item [0] ", result, item)
        if(result?.hasMenu && !result?.item?.enable) {
          let _message = result?.item?.message || 'Error message';
          MessageDisplayUtil.showErrorToast(_message,
          this.platform, this.toastCtl, 3000, 'bottom');
          return false;
        } else {
          if (item.label === 'About') {
            this.gotopage('tabs/about')
          }
          // else if (item.label === 'Help Content') {
          //   this.callHelpPage()
          // }
          else if (item.label === 'Send Feedback') {
            this.gotopage('tabs/feedback')
          }
          else if (item.label === 'Contact Us') {
            this.gotopage('tabs/contact-us')
          }
          else if (item.label === 'FAQs') {
            this.gotopage('tabs/faq')
          }
          else if (item.label === 'Change Password') {
            this.mdlCtrl.dismiss().then(() => {
              this.router.navigate(['change-password']);
            })
          }
          else if (item.label === 'Delete Account') {
            this.mdlCtrl.dismiss().then(() => {
              this.goClickAccountOption();
            })
          }
          else {
            let obj = {
              selectMenu: item.label,
              item: item
            }
            this.mdlCtrl.dismiss(obj);
          }
        }
      });



  }

  onClickMshipItem(label: string, item?: any) {
    let obj = {
      selectMenu: label,
      item: item
    }
    this.mdlCtrl.dismiss(obj);
  }


  async goClickAccountOption() {

    let modal = await this.mdlCtrl.create({
      component: AccountOptionPage,
      componentProps: {
        player: this.player$,
        friend: false
      }
    });
    modal.onDidDismiss().then((data: any) => {
      if (data && data?.data?.needRefresh) {
        this.playerHomeActions.setNeedRefresh(true);
      }
    });
    modal.present();
  }


  callHelpPage() {
    this.flightService.getHelp()
      .subscribe((helpURL: any) => {
        if (helpURL && helpURL.length > 0) {
          // && helpURL.length > 0
          this.helpURL = helpURL[0].url;

          window.open(this.helpURL, '_self');
        }
      }, (error) => {

      }, () => {
      })

  }

  gotopage(Pagename) {
    console.log('go to page : ', this.mdlCtrl, Pagename, this.getContactUsJson(), this.settingsAppAttribute);
    let _params: NavigationExtras;
    this.mdlCtrl.dismiss().then(() => {
      if(Pagename === 'tabs/contact-us') {
        _params = {
         state: {
          jsonUrl: this.getContactUsJson()
         }
        };
      }
      this.router.navigate([Pagename], _params)
    })
  }

  back() {
    this.mdlCtrl.dismiss();
  }

  async settings() {
    // this.mdlCtrl.dismiss().then(()=>{
    //   this.router.navigate(['tabs/settings'])    
    // })

    const modal = await this.mdlCtrl.create({
      component: SettingsComponent,
      cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      mode: 'ios',
    });
    await modal.present();
    modal.onDidDismiss().then(() => {
      modal.dismiss();
    })
  }

  localScorecards() {
    this.mdlCtrl.dismiss().then(() => {
      this.router.navigate(['scorecard-local-list']);
    })
  }
  eventLogs() {
    this.mdlCtrl.dismiss().then(() => {
      this.router.navigate(['event-log']);
    })
  }

  signoutMethod() {
    this.mdlCtrl.dismiss().then(() => {
      this.signout();
    })
  }

  onLabelClass(menuData: any) {
    if(menuData.label === 'Game in progress' && this.isNormaleGameOn)
      return true;
    else if(menuData.label === 'Tournament Scoring' && this.isCompOn)
    // else if(menuData.label === 'Find / Join Tournaments' && this.isCompOn)
      return true;
    else return false;

  }

  getContactUsJson() {
    
    let _contactUsJson;
    if(this.isClubSpecific && globals.appType && globals.clubId) {
        this.settingsAppAttribute.clubSpecific.filter((c)=>{
            return c.clubId === globals.clubId
        }).map((c)=>{
            _contactUsJson = c.contactUsPage;
        })
    } else {
        _contactUsJson = this.settingsAppAttribute.main.contactUsPage;
    }
    return _contactUsJson;
  }

  isDisabled(subMenu) {
    if(!this.appAttribute) return false;
    if(this.menuItems?.length === 0) return false;
    return this.menuItems?.find((item) => item.itemId === subMenu.itemId && item.enable === false)
  }

  

  checkMenuItem(item) {
    return new Promise((resolve, reject)=>{
      let _menuItems: Array<any> = this.appAttribute?.menuItems;
      console.debug("check menu item ", this.menuItems, item, this.appAttribute?.menuItems);
      let _item = null;
      if(_menuItems?.length > 0) {
        _item = _menuItems.find((mi)=>{
          return mi.itemId === item?.itemId
        })
        resolve({
          hasMenu: _item?true:false,
          item: _item
        })
      } else {
        resolve({
          hasMenu: false
        })
      }
    })
  }



}
